export default __webpack_public_path__ + "static/media/training-course.07a3946c.svg";